<template>
  <div class="bonus-change-info-modal">
    <div class="error-modal-body">
      <div class="service-board">
        <div class="close-btn">
          <div style="cursor: pointer" @click.esc="close">x</div>
        </div>
        <div class="text-body">
          <p>
            Эдийн засгийн төлөв байдал, хэрэглээний үнийн индексийн өсөлт,
            инфляцын түвшин зэрэг хүчин зүйлсээс шалтгаалан 2024.04.01-ний
            өдрөөс эхлэн Номин бонус картын хувь тооцох худалдан авалтын
            интервалыг шинэчлэхээр болсныг мэдэгдэж байна.
          </p>
          <p>
            Өөрчлөлтийн талаар дэлгэрэнгүйг үйлчилгээний нөхцөл рүү орж
            танилцана уу.
          </p>
          <p>Бидэнтэй үргэлж хамтдаа байдаг үнэнч хэрэглэгчдэдээ баярлалаа.</p>
        </div>
      </div>

      <div class="service-confirm">
        <b-form-checkbox
          id="checkbox-1"
          v-model="isChecked"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
        >
          Дахин харуулахгүй
        </b-form-checkbox>
      </div>
      <div class="container col-md-12 box-text top20">
        <div class="col-md-12 text-right">
          <button class="btn" @click.esc="sendConfirm" :disabled="inProcess">
            Хаах
          </button>
        </div>
      </div>
      <!-- </div> -->
    </div>

    <transition name="fade">
      <Number
        @setNumber="setNumber"
        v-if="checkNumber"
        :phone="user.idPhone"
      ></Number>
    </transition>

    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
  </div>
</template>

<script>
import Number from "../user/number/main";
import Error from "@/views/plugin/error";
import { Service } from "@/mixins/Service";
import { User } from "@/mixins/User";
import letterJSON from "@/json/data.vue";
export default {
  data() {
    return {
      phone: "",
      phone2: "",
      email: "",
      firstname: null,
      lastname: null,
      regFirst: null,
      regSecond: null,
      regThird: null,
      registerno: null,
      inProcess: false,
      checkNumber: false,
      serviceData: {},
      user: {},
      isChecked: false,
      errorMessage: "",
      errorModal: false,
      IsConfirmedInformation: 0,
      IsConfirmAgreement: 0,
      loader: false,
      letters: letterJSON.myJson,
      isPosCardConfirm: 0,
      bonus: false,
      loginLastName: "",
      loginFirstName: "",
      business: false,
    };
  },
  mixins: [Service, User],
  methods: {
    setNumber(phoneNumber) {
      this.phone = phoneNumber;
    },
    close() {
      this.$emit("hideBonusChangeModal");
    },
    getUser() {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }

      var customerInfo = this.$auth.getCardInfo();
      this.user = customerInfo;
      this.phone2 = customerInfo.customerPhone;
      this.email = customerInfo.customerEMail;
      this.firstname =
        customerInfo.firstName == "null" ? "" : customerInfo.firstName;
      this.lastname =
        customerInfo.lastName == "null" ? "" : customerInfo.lastName;
      this.registerno = customerInfo.customerRegNo;
      this.isPosCardConfirm = customerInfo.isPosCardConfirm;
      this.IsConfirmAgreement = customerInfo.IsConfirmAgreement;
      this.isConfirmInformation = customerInfo.IsConfirmInformation;

      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var resultInfo = response.data;
          if (resultInfo.status === 0) {
            if (resultInfo.CartType === "Business") {
              this.business = true;
            }
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    sendConfirm() {
      if (this.isChecked == "true") {
        console.log(this.isChecked, "12312");
        let phone = this.phone2;
        let firstname = this.firstname;
        let lastname = this.lastname;
        let email = this.email;
        let registerno = this.registerno;
        let tokenId = localStorage.getItem("authToken");
        let userData = this.$auth.getMe();
        let IsConfirmedInformation = 2;
        let IsConfirmAgreement = this.isChecked ? 1 : 0;

        if (tokenId == null || userData == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }

        console.log(
          JSON.stringify({
            tokenId,
            cardHolderInfId,
            phone,
            email,
            firstname,
            lastname,
            registerno,
            IsConfirmedInformation,
            IsConfirmAgreement,
          })
        );
        let cardHolderInfId = userData.cardHolderInfId;
        const checkResponse = this.checkByRegister(registerno);
        checkResponse.then((checkRes) => {
          if (checkRes.status !== true || this.isPosCardConfirm == 1) {
            this.$axiosApi
              .post(`card/update/holder/confirmOn`, {
                tokenId,
                cardHolderInfId,
                phone,
                email,
                firstname,
                lastname,
                registerno,
                IsConfirmedInformation,
                IsConfirmAgreement,
              })
              .then((response) => {
                var result = response.data;

                if (result.status === 0) {
                  this.isDisabled = false;
                  this.changeCardInfo();
                  this.$emit("showSuccessMessage", result.message);
                  this.$emit("hideBonusChangeModal");
                } else if (result.status === 100) {
                  this.errorMessage = response.data.message;
                  this.errorModal = true;
                  this.isDisabled = false;
                } else if (result.status === 201) {
                  this.RedirectLogin();
                  this.$auth.destroyToken();
                  this.$auth.removeMe();
                  this.$router.push({ name: "login" });
                }
              })
              .catch(() => {
                this.RedirectLogin();
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
              });
          } else {
            this.errorModal = true;
            this.errorMessage = "Таны оруулсан регистр бүртгэлтэй байна ?";
          }
        });
      } else {
        this.$emit("hideBonusChangeModal");
      }
    },
    hideErrorMessage() {
      this.errorMessage = "";
      this.errorModal = false;
    },
    changeCardInfo() {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();

      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          {
            tokenId: tokenId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            //remove cardInfo
            this.$auth.removeCardInfo();
            //set cardInfo
            this.$auth.setCardInfo(result);
          } else if (result.status === 201) {
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    // bonusTransfer(){
    //     this.inProcess = true;
    //     this.$emit('bonusTransfer');
    // }
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
      this.loginLastName = cardHolderInfo.lastName;
      this.loginFirstName = cardHolderInfo.firstName;
    },
  },
  created() {
    this.getUser();
    this.fetchData();
    this.cardInfoList();
  },
  components: {
    Number,
    Error,
  },
};
</script>
<style scoped>
.my-info {
  margin: 5px 20px !important;
  padding: 5px 20px !important;
  border: 1px solid #1660ab85;
  background: rgb(199 193 193 / 9%);
  color: black !important;
  font-weight: 300;
  font-size: 13px !important;
  text-align: center;
}

.my-info::before {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  display: block;
  left: 50%;
  top: -10px;
  border-bottom-color: #08c;
}

.row {
  margin-right: 0;
}

.close-btn {
  position: absolute;
  color: #000;
  flex-direction: row;
  justify-content: flex-end;
  /* width: 100%; */
  padding: 0 10px;
  font-size: 28px;
  right: 0;
  top: 0;
}

.service-confirm {
  text-align: right;
  width: 100%;
  padding: 0 10px;
  font-size: 13px;
  line-height: 2;
  color: #1660ab;
  margin-bottom: 10px;
}

.service-confirm input {
  margin-right: 5px;
  outline: 1px solid #ddd;
}

p input {
  font-size: 13px;
}

.text-right {
  text-align: right;
}

.user-id {
  height: 30px;
  flex: 2;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.user-id div {
  padding: 0.375rem 0.75rem;
  width: 149px;
  height: 30px;
  mix-blend-mode: multiply;
  border-radius: 3px;
  background-color: #ebebeb;
  font-size: 12px;
}

.user-id img {
  margin-left: 13px;
  width: 17px;
  height: 16px;
  display: flex;
  align-self: center;
  cursor: pointer;
  position: absolute;
  right: 0;
}

.user-id span {
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.6;
  letter-spacing: normal;
  color: #1660ab;
  margin-left: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: -65px;
}

.head {
  border-bottom: 1px solid #1660ab;
  width: 100%;
  margin: 0;
  color: #1660ab !important;
  margin-bottom: 10px !important;
}

.box-info p {
  color: red;
  margin-top: 10px !important;
  font-size: 15px;
}

.service-board {
  width: 100%;
  padding: 10px 0;
  /* box-shadow: 0px 2px 8px 0 rgba(0, 0, 0, 0.2); */
  background: #fff;
  border-radius: 3px;
  overflow: auto;
  max-height: 350px;
  border: 1px solid #ccc;
  margin: 10px;
}

.service-header {
  text-align: center;
  font-size: 18px;
  color: #1660ab;
  padding: 5px 10px;
}

.service-body {
  text-align: justify;
  font-size: 13px;
  line-height: 1;
  padding: 10px;
}

.service-body p {
  margin-bottom: 0.4rem;
}

.txt-size p {
  margin: 0;
  margin-bottom: 5px !important;
  color: #ff0000;
}

.bonus-change-info-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
}

.error-modal-body {
  position: fixed;
  width: 500px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 auto;
  padding-bottom: 30px;
  overflow-x: auto;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.title {
  float: left;
}

.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}

.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}

.box-text {
  padding-left: 40px;
}

.box-text p {
  margin: 0;
  border: none;
  color: black;
  font-size: 14px;
}

.box-text h2 {
  padding: 5px 0;
  font-size: 13px;
  margin: 0;
  color: black;
  font-weight: 500;
  line-height: 2;
}

.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}

.btn {
  background-color: #1660ab;
  color: #fff;
  padding: 3px 50px;
  margin-left: 16px;
}

.btn.redColor {
  background-color: #ed3237;
}

.top20 {
  margin-top: 20px;
}

.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}

.error-modal-body div p {
  margin: 0;
  padding: 5px 0;
}

.error-modal-body .error-img {
  margin-top: 37px !important;
  height: 49px;
  flex: 0.5;
  padding-left: 18px;
  line-height: 1.38;
}

.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}

.error-modal-body img {
  cursor: pointer;
}

.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}

.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.exitBtn {
  top: 0;
  right: 0;
  color: #fff;
  width: 32px;
  height: 32px;
  position: absolute;
}

.text-body h2 {
  text-align: center;
  font-size: 16px;
  padding-bottom: 10px;
}

.text-body p {
  font-size: 13px;
  text-align: justify;
}

.footer-text {
  margin: 0;
  padding: 0;
  padding-left: 40px;
}

.footer-text p {
  margin: 0;
  padding: 0;
  font-size: 13px;
  padding-bottom: 2px;
}

.footer-text i {
  color: #32cd32;
}

.imgDev {
  position: absolute;
  top: 0;
  left: 120px;
}

.imgDev img {
  height: 150px;
}

@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 10%;
    position: sticky;
  }
}

@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 10%;
    width: 80%;
    position: sticky;
  }
}

.bonus-transfer {
  margin: 0;
  padding: 10px 14px;
  border: 1px dashed #bdbdbd;
  margin-top: 14px;
}

.bonus-transfer p {
  margin: 0;
  font-size: 12px;
}

.colorRed {
  color: #ed3237;
}

.bonus-transfer b {
  color: #1660ab;
}

@media screen and (max-width: 767px) {
  .error-modal-body {
    width: 100%;
    top: 0;
  }

  .col-md-6 {
    width: 100%;
  }

  .col-md-4 {
    max-width: 100%;
  }

  .col-md-8 {
    max-width: 100%;
    padding-left: 10px;
  }

  .box-text h2 {
    font-size: 12px;
  }

  .box-text p {
    font-size: 12px;
  }

  .btn {
    padding: 5px 10px;
    font-size: 14px;
  }

  .service-board {
    padding: 0;
  }

  .service-confirm {
    text-align: left;
    line-height: 1.2em;
  }

  .user-id {
    flex-wrap: nowrap;
  }

  .box-text {
    padding-left: 30px;
  }
}
</style>
